import { LoginTemplate } from "../../components/templates/Login"

export function Component() {
  return <LoginTemplate />
}
